import {
    SkyNetTableField,
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    ContactMainType,
} from 'app/enums/label.enums'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    ContactsTableTabs,
} from 'app/enums/domain.enums'
import {
    Contact,
} from './Contacts.types'

type ContactTable = Contact & {
    locationLocationName: string,
    locationCompanyCompanyName: string
}

const locationField: SkyNetTableField<keyof ContactTable>[] = [{
    name: 'locationLocationName',
    filterField: 'locationLocationName',
    labelKey: 'Contact.location',
}]
const basicFields: SkyNetTableField<keyof ContactTable>[] = [
    {
        name: 'contactName',
        filterField: 'contactName',
        reduced: true,
        labelKey: 'Contact.contactName',
    },
    {
        name: 'email',
        filterField: 'email',
        labelKey: 'Contact.email',
    },
    {
        name: 'phone',
        filterField: 'phone',
        labelKey: 'Contact.phone',
    },
    {
        name: 'isMainContact',
        componentName: 'ChipCheckMark',
        labelKey: 'Contact.isMainContact',
    },
    {
        name: 'countryCountryName',
        labelKey: 'Country.basedInCountry',
    },
]

const restFields: SkyNetTableField<keyof ContactTable>[] = [
    {
        name: 'mainType',
        componentName: 'EnumList',
        allowedValuesEnum: ContactMainType,
        labelKey: 'Contact.mainType',
    },
    {
        name: 'createdOn',
        labelKey: 'Accounts.createdOn',
    },
    {
        name: 'createdBy',
        filterField: 'createdBy',
        labelKey: 'AccountQuotes.createdBy',
    },
]

const config: SkyNetTableConfig<keyof ContactTable> = {
    name: 'ContactsTable',
    tabs: [
        {
            name: 'Contacts',
            url: CommonRoutes.All,
            includeFilters: {
                isProspect: [false],
            },
            fields: [
                ...basicFields,
                ...locationField,
                ...[{
                    name: 'locationCompanyCompanyName',
                    filterField: 'locationCompanyCompanyName',
                    reduced: true,
                    labelKey: 'Location.company',
                }] as SkyNetTableField<keyof ContactTable>[],
                ...restFields,
            ],
        },
        {
            name: 'Prospect Contacts',
            url: ContactsTableTabs.Prospect,
            requestUrl: 'all',
            includeFilters: {
                isProspect: [true],
            },
            fields: [
                ...basicFields,
                ...[{
                    name: 'companyCompanyName',
                    filterField: 'companyCompanyName',
                    reduced: true,
                    labelKey: 'Location.company',
                }] as SkyNetTableField<keyof ContactTable>[],
                ...restFields,
            ],
        },
    ],
}

export default config
